import React from 'react'
import { useDeletePricingVersion } from '../../../hooks/global-job-matching'
import { Button, Group, LoadingOverlay, Modal, Stack, Text } from '@mantine/core'
import { PricingVersion } from '../GlobalJobMatchingVersioning/types/versions'

export const DeleteVersionModal = ({ opened, onClose, selectedVersion }: { opened: boolean, onClose: () => void, selectedVersion?: PricingVersion }) => {
  const { mutate: deleteVersion, isLoading: isDeleting, isSuccess, reset } = useDeletePricingVersion()

  if (isSuccess) {
    reset()
    onClose()
  }

  if (!selectedVersion) return

  return (
    <Modal size='xl' opened={opened} onClose={onClose} title='Delete Version'>
      <Stack>
        <LoadingOverlay visible={isDeleting} />
        <Text>You have selected to delete version <Text span fw='bold'>{selectedVersion?.name}.</Text> Please confirm your choice, or cancel and return to the page.</Text>
        <Group justify='flex-end' mt='xl'>
          <Button size='lg' onClick={onClose}>Cancel</Button>
          <Button size='lg' color='red' onClick={() => deleteVersion(selectedVersion?.id)}>Delete</Button>
        </Group>
      </Stack>
    </Modal>
  )
}

